import * as Yup from 'yup';
import INPUT_IDS from '@constants/inputs/userDataInputs';
import useAppConfig from '@hooks/useAppConfig';
import { useDefaultSchemaYup } from '@utils/yupMethods';

export const initialValues = {
  [INPUT_IDS.FIRST_NAME]: '',
  [INPUT_IDS.LAST_NAME]: '',
  [INPUT_IDS.EMAIL]: '',
  [INPUT_IDS.PHONE]: { number: '', countryCode: '' },
  [INPUT_IDS.SERVICE_AGREEMENT]: false,
  [INPUT_IDS.EMAIL_CONSENT]: false,
  [INPUT_IDS.SMS_CONSENT]: false,
  [INPUT_IDS.PHONE_CONSENT]: false,
};

export const useValidationSchema = ({
  demandPhoneNumber,
  phoneNumber,
  firstName,
  lastName,
  email,
  needServiceTerms,
}) => {
  const { stringRequired, phoneValid, emailRequired, booleanRequired } =
    useDefaultSchemaYup();
  const {
    data: { brandTerms },
  } = useAppConfig();
  const validate = {};

  if (demandPhoneNumber && !phoneNumber) {
    validate[INPUT_IDS.PHONE] = phoneValid;
  }

  if (!firstName) {
    validate[INPUT_IDS.FIRST_NAME] = stringRequired;
  }

  if (!lastName) {
    validate[INPUT_IDS.LAST_NAME] = stringRequired;
  }

  if (!email) {
    validate[INPUT_IDS.EMAIL] = emailRequired;
  }

  if (needServiceTerms) {
    validate[INPUT_IDS.SERVICE_AGREEMENT] = booleanRequired;

    if (brandTerms.find(term => term.type === 'EMAIL')?.active) {
      validate[INPUT_IDS.EMAIL_CONSENT] = Yup.boolean();
    }
    if (brandTerms.find(term => term.type === 'SMS')?.active) {
      validate[INPUT_IDS.SMS_CONSENT] = Yup.boolean();
    }
    if (brandTerms.find(term => term.type === 'PHONE')?.active) {
      validate[INPUT_IDS.PHONE_CONSENT] = Yup.boolean();
    }
  }

  return Yup.object(validate);
};
